import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Menu.css";
import { Context } from "../../context/Context";

const Menu = (props) => {
  const { setShowDrawerSidebar } = useContext(Context);

  const [unreadCount, setUnreadCount] = useState(
    localStorage.getItem("notifications_count")
      ? localStorage.getItem("notifications_count")
      : 0
  );

  const isCompanyAdmin =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).company_admin === 1
        ? true
        : false
      : false;

  useEffect(() => {
    if (!isCompanyAdmin) {
      getNotificationsUnread();
    }
  // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("userData")) &&
      JSON.parse(localStorage.getItem("userData")).id
    ) {
      const eventSource = new EventSource(
        window.ajaxLink +
          "updatesse/events?observeData=cloudNotifications&valueName=" +
          JSON.parse(localStorage.getItem("userData")).id.toString()
      );
      eventSource.onmessage = (e) => {
        if (e.data.toString().toLowerCase() === "update") {
          getNotificationsUnread();
        }
      };
      return () => {
        eventSource.close();
      };
    }
  // eslint-disable-next-line
  }, []);

  const getNotificationsUnread = () => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      axios.defaults.headers.common["Authorization"] = JSON.parse(
        localStorage.getItem("userData")
      ).token;
      axios
        .post(window.ajaxLink + "notifications/getUnreadCount", {})
        .then((res) => {
          if (res.data.responseData) {
            // console.log(res.data.responseData);
            setUnreadCount(res.data.responseData[0]["COUNT(*)"]);
            localStorage.setItem(
              "notifications_count",
              res.data.responseData[0]["COUNT(*)"]
            );
            //handleNotifications(res.data.responseData);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  return (
    <div>
      <div className="menu_hold">
        <div className="menu_title_container">
        <div
          className="menu_btn"
          onClick={() => setShowDrawerSidebar(true)}
        ></div>
        <div className="main_title">{props.title}</div>
        </div>


        {props.disableBell
          ? ""
          : (
              <Link to="/notifications">
                <div className="menu_btn menu_bell">
                  <span
                    style={unreadCount <= 0 ? {display: 'none'} : {}}
                    className={
                      "menu_bell_counter" +
                      (unreadCount < 10
                        ? " count_one"
                        : unreadCount < 100
                        ? " count_two"
                        : " count_three")
                    }
                  >
                    {unreadCount}
                  </span>
                </div>
              </Link>
            )}
      </div>
    </div>
  );
};

export default Menu;
